import { atom, selector } from 'recoil'

const MAX_RECENT_TRADES_ROW = 50

let tradeHistorySerialId = 0

function addSerialId(recentTrades) {
  return recentTrades.map(tradeHistory => {
    tradeHistory.id = `${tradeHistory.ts}${tradeHistorySerialId}`
    tradeHistorySerialId++
    return tradeHistory
  })
}

export const _recentTradesState = atom({
  key: '_RecentTrades',
  default: {
    symbol: '',
    list: []
  }
})

export const recentTradesState = selector({
  key: 'RecentTrades',
  get: ({ get }) => get(_recentTradesState),
  set: ({ get, set, reset }, { marketSymbol, recentTrades }) => {
    if (marketSymbol) {
      tradeHistorySerialId = 0
      set(_recentTradesState, {
        symbol: marketSymbol,
        list: addSerialId(recentTrades)
      })
      return
    }

    const { symbol, list } = get(_recentTradesState)
    set(_recentTradesState, {
      symbol,
      list: addSerialId(recentTrades)
        .concat(list)
        .slice(0, MAX_RECENT_TRADES_ROW)
    })
  },
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})
